export default __webpack_public_path__ + "static/screeny-85-gpz-s-scheda-tecnica-3aeb3b127fd55daf20cd9afa329ab8ac.pdf";